<template>
  <div class="box sc-consolidate-lp">
    <sc-table
      :data="consolidatedLp"
      :bordered="true"
      :paginated="consolidatedLp.length > 10"
      :per-page="filters.perPage">
      <template slot-scope="props">
        <sc-table-column
          field="logistic_provider_name"
          label="Transportadora"
          sortable>
          {{ props.row.logistic_provider_name }}
        </sc-table-column>

        <sc-table-column
          field="invoices_count"
          label="Qtd de Notas Fiscais"
          sortable>
          {{ props.row.invoices_count }}
        </sc-table-column>

        <sc-table-column
          field="tms_freight_value"
          label="Frete Total TMS"
          sortable>
          {{ props.row.tms_freight_value | currency }}
        </sc-table-column>

        <sc-table-column
          field="lp_freight_value"
          label="Frete Total Transportadora"
          sortable>
          {{ props.row.lp_freight_value | currency }}
        </sc-table-column>
      </template>

      <template slot="empty">
        <sc-table-empty />
      </template>
    </sc-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScTable,
  ScTableColumn,
  ScTableEmpty,
} from '@intelipost-js/secure-components';

const { mapState, mapActions } = createNamespacedHelpers('recon/analytics/consolidatedLp');

export default {
  name: 'sc-analytics-consolidated-lp',
  data() {
    return {
      filters: {
        perPage: 10,
      },
    };
  },
  computed: {
    ...mapState([
      'consolidatedLp',
    ]),
  },
  methods: {
    ...mapActions([
      'getConsolidatedLp',
    ]),
    loadData(params) {
      return this.getConsolidatedLp(params);
    },
  },
  components: {
    ScTable,
    ScTableColumn,
    ScTableEmpty,
  },
};
</script>

<style lang="scss" scoped>
.sc-consolidate-lp {
  padding-bottom: 0;
  min-height: 500px;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-consolidated-lp/ScAnalyticsConsolidatedLp.vue?7739b35e